export enum LineStatus {
  LINE_UNSET = 'LINE_UNSET', // Do not use, needed because of proto3 limitations
  PENDING = 'PENDING',
  ACTIVATED = 'ACTIVATED',
  TERMINATED = 'TERMINATED',
  DEACTIVATED = 'DEACTIVATED',
  INITIATING = 'INITIATING',
  ACTIVATION_FAILED = 'ACTIVATION_FAILED',
  DEACTIVATING = 'DEACTIVATING',
  TERMINATING = 'TERMINATING',
  ACTIVATING = 'ACTIVATING',
}
